import { ErrorCode } from "@bonliva-crm/common";

/**
 * The error code the API puts in `extensions.code` (see its `formatError`), read
 * off an ApolloError-shaped value. Null for anything without one, including a
 * plain Error.
 */
export function graphQLErrorCode(error: unknown): ErrorCode | null {
  const graphQLErrors = (
    error as { graphQLErrors?: { extensions?: { code?: string } }[] }
  )?.graphQLErrors;

  const code = graphQLErrors?.[0]?.extensions?.code;

  return code ? (code as ErrorCode) : null;
}
